module.exports = __webpack_public_path__ + "img/logo_notext.7650fe6e.png";